import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get , post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompElectric({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [infoElectricComponent, setInfoCompElectric] = useState({
    Engine_start: 0,
    Air_conditioning: 0,
    Heating: 0,
    Electric_windows: 0,
    Electric_Mirrors: 0,
    Front_windshield_wiper: 0,
    Rear_windshield_wiper: 0,
    Radio: 0,
    Whistle: 0,
    Clock: 0,
    Tachometer: 0,
    Sunroof: 0,
    odometer: 0,
    center_lock: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'EC', data: infoElectricComponent });
  });

  const handleForm = ({ target }) => {
    const tmpElectricComp = { ...infoElectricComponent, [target.name]: target.value }
    setInfoCompElectric(tmpElectricComp);
    autosave.schedule();
    //generalUpdate('infoElectricComponent', tmpElectricComp)
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get( `/peritaje/infostate/C` ,  {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e)=> e.name.toLowerCase()==='bueno')
      setInfoCompElectric({
        Engine_start: currentDefaultState.id,
        Air_conditioning: currentDefaultState.id,
        Heating: currentDefaultState.id,
        Electric_windows: currentDefaultState.id,
        Electric_Mirrors: currentDefaultState.id,
        Front_windshield_wiper: currentDefaultState.id,
        Rear_windshield_wiper: currentDefaultState.id,
        Radio: currentDefaultState.id,
        Whistle: currentDefaultState.id,
        Clock: currentDefaultState.id,
        Tachometer: currentDefaultState.id,
        Sunroof: currentDefaultState.id,
        odometer: currentDefaultState.id,
        center_lock: currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = {type:'EC', data :infoElectricComponent};
    const respo = await post('/peritaje/modifyinspection/components/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'EC' };
      const tmpElectric = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const {detail} = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpElectric[element.name] = element.id_state;
        }
        if(detail.length>0) setInfoCompElectric(tmpElectric);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner />  : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">EQUIPAMIENTO ELECTRICO</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Engine_start">Arranque de motor</Form.Label>
          <Form.Select
            name="Engine_start"
            value={infoElectricComponent.Engine_start}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Air_conditioning">Aire Acondicionado</Form.Label>
          <Form.Select
            name="Air_conditioning"
            value={infoElectricComponent.Air_conditioning}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Heating">Calefaccion</Form.Label>
          <Form.Select
            name="Heating"
            value={infoElectricComponent.Heating}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Electric_windows">Elevavidrios electrico</Form.Label>
          <Form.Select
            name="Electric_windows"
            value={infoElectricComponent.Electric_windows}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Electric_Mirrors">Espejos Electricos</Form.Label>
          <Form.Select
            name="Electric_Mirrors"
            value={infoElectricComponent.Electric_Mirrors}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Front_windshield_wiper">Limpia brisas delantero</Form.Label>
          <Form.Select
            name="Front_windshield_wiper"
            value={infoElectricComponent.Front_windshield_wiper}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Rear_windshield_wiper">Limpia brisas trasero</Form.Label>
          <Form.Select
            name="Rear_windshield_wiper"
            value={infoElectricComponent.Rear_windshield_wiper}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Radio">Radio</Form.Label>
          <Form.Select
            name="Radio"
            value={infoElectricComponent.Radio}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Whistle">Pito</Form.Label>
          <Form.Select
            name="Whistle"
            value={infoElectricComponent.Whistle}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Clock">Reloj</Form.Label>
          <Form.Select
            name="Clock"
            value={infoElectricComponent.Clock}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Tachometer">Tacometro</Form.Label>
          <Form.Select
            name="Tachometer"
            value={infoElectricComponent.Tachometer}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Sunroof">Sunroof</Form.Label>
          <Form.Select
            name="Sunroof"
            value={infoElectricComponent.Sunroof}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="odometer">Odometro</Form.Label>
          <Form.Select
            name="odometer"
            value={infoElectricComponent.odometer}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="center_lock">Bloqueo Central</Form.Label>
          <Form.Select
            name="center_lock"
            value={infoElectricComponent.center_lock}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
          {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompElectric;
